/**
 * @file api-shop-domains.ts
 * @description Адреса сайта в кабинете МАГАЗИНА (phase19.28 этап А;
 * shop-cabinet.md «домены в кабинете магазина — только чтение и заявка»;
 * PL11): список только для чтения и заявка платформе на свой домен.
 * Контекст SHOP, право `SHOP_MANAGE_SETTINGS`. Подключает домен владелец
 * платформы — по заявке.
 */

import { apiFetch } from "./api-client";
import type { ShopDomain } from "./api-platform-shops";

/** Ответ заявки: `sentToPlatform: false` — письмо не ушло, заявка видна в карточке магазина. */
export interface ShopDomainRequestResult {
  host: string;
  hostUnicode: string;
  status: "requested";
  sentToPlatform: boolean;
}

export const shopDomains = {
  list: () => apiFetch<ShopDomain[]>("/admin/shop/domains"),
  request: (payload: { host: string; comment?: string }) =>
    apiFetch<ShopDomainRequestResult>("/admin/shop/domains/request", { method: "POST", json: payload }),
};
